export default function Logo() {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 134 20"
      width="134"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M67.8115 0.000404358H71.6701V19.6465H67.8115V0.000404358Z"
        fill="#520313"
      />
      <path
        d="M59.8799 0.000350952H63.7011V19.6469H59.8799V0.000350952Z"
        fill="#520313"
      />
      <path
        d="M49.5285 20.0003C45.3982 20.0003 42.2461 16.7939 42.2461 12.881C42.2461 8.99524 45.4253 5.78882 49.5285 5.78882C53.686 5.78882 56.838 9.02241 56.838 12.881C56.838 16.7939 53.6588 20.0003 49.5285 20.0003ZM49.5285 16.3863C51.5121 16.3863 52.9795 14.8103 52.9795 12.9082C52.9795 11.006 51.5121 9.43001 49.5285 9.43001C47.5448 9.43001 46.1047 11.006 46.1047 12.9082C46.1047 14.8103 47.5448 16.3863 49.5285 16.3863Z"
        fill="#520313"
      />
      <path
        d="M23.5585 9.56582C21.3847 9.56582 20.4064 11.3321 20.4064 13.3972V19.647H16.5479V12.9353C16.5479 9.02236 18.8576 5.81594 23.5585 5.81594C28.2594 5.81594 30.6235 8.99519 30.6235 12.9353V19.647H26.7649V13.3972C26.7649 11.3321 25.7595 9.56582 23.5585 9.56582Z"
        fill="#520313"
      />
      <path
        clipRule="evenodd"
        d="M37.299 13.4294C37.299 11.3642 38.2772 9.59797 40.4511 9.59797V5.84808C35.7501 5.84808 33.4404 9.05451 33.4404 12.9674V19.6792H37.299V13.4294Z"
        fill="#520313"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M7.33673 19.6913C3.15208 19.6913 0 17.2468 0 12.9534C0 9.06767 2.826 5.86124 6.98348 5.86124C11.2497 5.86124 13.7224 9.01332 13.7224 12.6817V14.4403H4.18569C4.62983 15.2788 5.47863 16.1947 7.46388 16.1947H13.7224V19.6913H7.33673ZM9.73667 11.522H4.04008C4.24401 10.3404 5.27158 9.2307 6.95631 9.2307C8.58669 9.2307 9.64547 10.2632 9.73667 11.522Z"
        fill="#520313"
        fillRule="evenodd"
      />
      <path
        d="M130.418 19.7251C126.532 19.7251 124.603 17.3882 124.603 14.0188V9.15479V5.89402V2.47021H128.461V5.36336H133.216V8.62413H128.461V13.9101C128.461 15.4046 129.358 16.2741 130.771 16.2741C131.559 16.2741 132.564 16.0296 133.216 15.622V19.073C132.537 19.5077 131.369 19.7251 130.418 19.7251Z"
        fill="#939393"
      />
      <path
        d="M99.3771 19.6982C95.4642 19.6982 92.7197 16.4918 92.7197 12.5789C92.7197 8.7203 95.8718 5.48671 100.002 5.48671C104.214 5.48671 107.312 8.53009 107.312 12.5789V19.345H103.643V17.7689C102.692 18.9646 101.225 19.6982 99.3771 19.6982ZM100.002 16.0842C101.986 16.0842 103.453 14.5082 103.453 12.6061C103.453 10.7039 101.986 9.1279 100.002 9.1279C98.0185 9.1279 96.5783 10.7039 96.5783 12.6061C96.5783 14.5082 98.0185 16.0842 100.002 16.0842Z"
        fill="#939393"
      />
      <path
        d="M115.785 16.4205C117.035 16.4205 117.823 15.9313 117.823 15.1433C117.823 12.9695 110.432 14.8444 110.432 9.65437C110.432 7.23596 112.551 5.33385 115.866 5.33385H121.301V8.4044H115.948C114.997 8.4044 114.29 8.86635 114.29 9.57285C114.29 11.7467 121.681 10.0076 121.681 15.0618C121.681 17.7791 119.045 19.5182 115.975 19.5182H110.105V16.4205H115.785Z"
        fill="#939393"
      />
      <path
        clipRule="evenodd"
        d="M77.625 12.4262C77.625 16.3119 80.8042 19.5455 84.853 19.5184V15.8772C82.9237 15.8772 81.4836 14.3283 81.4836 12.4262C81.4836 10.5241 82.9237 8.97521 84.853 8.97521C86.1845 8.97521 87.2714 9.70888 87.8692 10.8773L91.0485 9.13825C89.8257 6.52963 87.4345 5.36119 84.853 5.33402C80.8042 5.30684 77.625 8.51327 77.625 12.4262Z"
        fill="#939393"
        fillRule="evenodd"
      />
      <path
        d="M84.853 15.8772V19.5184H91.0485V15.8772H84.853Z"
        fill="#939393"
      />
    </svg>
  );
}
